<section class="toggle-form" [ngClass]="{ active: isSliderOpen }" style="overflow-y: auto">
    <div class="formwrap">
      <p-panel header={{sliderHeaderText}}>
        <ng-template pTemplate="icons">
          <p-button appPreventDoubleClick styleClass="p-button-text" id="sliderCloseButton" type="button" label="Close" class="align-right"
            (debounceClick)="closeSlider()"></p-button>
        </ng-template>
          <div *ngIf="errorMessages.length > 0">
            <p-messages severity="error">
              <ng-template pTemplate>
                <span class="p-message-icon pi pi-times-circle"></span>
                <span class="p-ml-2"
                  >{{errorHeading}}</span
                >
                <ul>
                  <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
                </ul>
              </ng-template>
            </p-messages>
          </div>
          <div class="fields-row">
            <div class="field field-title field-required">
                <bpt-text-input
                [(ngModel)]="commentText"
                [multiLine]="true"
                [required]="true"
                id="documentCommentText"
                label="Comment Text"
                ></bpt-text-input>
            </div>
          </div>
          <p-button
            appPreventDoubleClick
            label="Save"
            type="save"
            id="saveDocumentCommentBtn"
            class="align-right mt-4"
            (debounceClick)="saveDocumentComment()"
          >
          </p-button>
      </p-panel>
    </div>
  </section>